import React from 'react';

function AboutPage() {
  return (
    <div className="min-h-screen bg-buxDollarGreen flex items-center justify-center p-4 font-pixel">
      <div className="max-w-4xl w-full">
        <h1
          className="text-4xl text-buxYellow mb-8 text-center"
          style={{
            textShadow: `
              -2px -2px 0 #000000,  
               2px -2px 0 #000000,
              -2px  2px 0 #000000,
               2px  2px 0 #000000,
              -4px  0px 0 #000000,
               4px  0px 0 #000000,
               0px -4px 0 #000000,
               0px  4px 0 #000000
            `,
          }}
        >
          About BUX
        </h1>
        <div className="bg-buxBlack text-white p-6 rounded shadow-pixel space-y-6">
          <p className="font-bold">
            Win every hour, win every day.
          </p>
          <p>
            BUX is a coin with builtin automated ETH rewards. Each buy or sell funds two pools - Hourly and Daily - that pay out ETH to randomly selected holders.
          </p>
          <div>
            <h2 className="text-2xl text-buxYellow mb-4" style={{ textShadow: ' -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000 ' }}>How It Works</h2>
            <ol className="list-decimal list-inside space-y-2 text-sm">
              <li>Buy or sell BUX → ETH fees go to reward pools.</li>
              <li>Chainlink VRF randomly selects eligible holders hourly and daily.</li>
              <li>ETH is sent directly to recipients on-chain.</li>
            </ol>
          </div>
          <p className="font-bold">
            Fully transparent. Immutable. Audited.
          </p>
          <div>
            <h2 className="text-2xl text-buxYellow mb-4" style={{ textShadow: ' -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000 ' }}>Fee Breakdown</h2>
            <p className="mb-2">Every transaction includes a 12.25% ETH fee:</p>
            <ul className="list-disc list-inside space-y-2 text-sm">
              <li>7.90% → Hourly Rewards</li>
              <li>3.50% → Daily Rewards</li>
              <li>0.85% → Team (ops, audits)</li>
            </ul>
          </div>
          <p>
            All fees are paid in ETH — never from your BUX balance.
          </p>
          <div>
            <h2 className="text-2xl text-buxYellow mb-4" style={{ textShadow: ' -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000 ' }}>Fair & Transparent</h2>
            <ul className="list-disc list-inside space-y-2 text-sm">
              <li>1 BUX = 1 eligibility point.</li>
              <li>No burning, no multipliers.</li>
              <li>All data and results verifiable on-chain.</li>
            </ul>
          </div>
          <div className="flex justify-center space-x-4 mt-6">
            <a
              href="/#"
              className="relative
        bg-buxGreen 
        text-buxYellow
        font-pixel 
        px-8 py-4
        border-4 border-black
        before:content-['']
        before:absolute
        before:top-1
        before:left-1
        before:right-1
        before:bottom-1
        before:border-2
        before:border-white
        before:pointer-events-none
        shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]
        hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]
        hover:translate-x-[3px]
        hover:translate-y-[3px]
        active:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]
        active:translate-x-[5px]
        active:translate-y-[5px]
        transition-all
        text-sm"
            >
             Home 
            </a>
            <a
              href="/buy"
              className="relative
        bg-buxYellow 
        text-buxBlack 
        font-pixel 
        px-8 py-4
        border-4 border-black
        before:content-['']
        before:absolute
        before:top-1
        before:left-1
        before:right-1
        before:bottom-1
        before:border-2
        before:border-white
        before:pointer-events-none
        shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]
        hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]
        hover:translate-x-[3px]
        hover:translate-y-[3px]
        active:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]
        active:translate-x-[5px]
        active:translate-y-[5px]
        transition-all
        text-sm"
            >
              Buy BUX
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;